import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { format } from "date-fns";
//api
import { getDetailUser, editUser, deleteUser } from 'api/users';
//components
import Title from 'components/backoffice/texts/title';
import UserForm from 'components/backoffice/forms/userForm';

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [backendErrors, setBackendErrors] = useState({})

  const { t } = useTranslation(['backoffice']);

  const { setTitle} = useOutletContext()

  const detailUser = async () => {
    try {
      const { data, status } = await getDetailUser(id);
      if (status === 200) {
        setUser(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    detailUser();
  }, []);

  useEffect(() => {
    if(user){
      setTitle(t('edit', {title: user?.full_name}));
    }
    return () => {
      setTitle(''); 
    };
  },[user, setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      email: values.email,
      first_name: values.first_name,
      last_name: values.last_name,
      is_active: values.is_active,
      username: values.username,
      profile: values.profile,
    };

    switch (values.profile) {
      case 'normal':
        data['benefited_bookstore'] = {
          value: parseInt(values.benefited_bookstore)
        }
        data['dni'] = values.dni
        data['phone_number'] = values.phone_number
        data['date_birth'] = format(values.date_birth, 'yyyy-MM-dd')
        break;
      case 'worker':
        data['job'] = values.job
        data['supervisor'] = values.supervisor
        data['is_administrator']= values.is_administrator
        break;
      case 'commercial':
        data['margin_library'] = values.margin_library
        data['margin_bookstore'] = values.margin_bookstore
        break;
      case 'library':
        data['library'] = values.library.id
        break;
      default:
        break;
    }

    try {
      const response = await editUser(id, data);
      const { status } = response;
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/users', { replace: true });
      } else if ( response?.status === 400 && response?.data ) {
        setBackendErrors(response?.data)
      }else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteUser(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/users', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);

  return (
    <div className="mt-2">
      <Title text={t('edituser')} />
      <UserForm 
        loading={loading} 
        isEditing={true} 
        onSubmitForm={onSubmit} 
        openModalDelete={openModalDelete} 
        setOpenModalDelete={setOpenModalDelete} 
        defaultValues={user} 
        onDelete={handleDelete} 
        id={id} 
        backendErrors={backendErrors}
      />
    </div>
  );
};

export default EditUser;
